<ui-input-wrapper
  [label]="base.label"
  [labelTemplate]="base.labelTemplate"
  [extendedHelpTooltip]="base.extendedHelpTooltip()"
  [help]="base.help"
  [helpTooltipPosition]="base.helpTooltipPosition()"
  [hintTemplate]="base.hintTemplate"
  [hint]="base.hint"
  [maxLength]="text.maxLength ?? 1000"
  [errors]="control.errors"
  [submitted]="submitted"
  [forceShowValidationErrors]="base.forceShowValidationErrors()"
  [errorLabels]="base.errorLabels()"
  [control]="control"
  [valueLength]="nativeInputElement.value.length">
  <textarea
    pTextarea
    class="__textarea block w-full max-w-full mt-1.25 box-border resize-none"
    [formControl]="$any(control)"
    #nativeInputElement
    [readonly]="base.readonly()"
    [attr.maxlength]="text.maxLength"
    [rows]="textarea.rows()"
    (input)="text.valueChange.emit($any($event.currentTarget).value)"
    [attr.placeholder]="base.placeholder ?? base.label"
    [attr.name]="base.name()">
  </textarea>
</ui-input-wrapper>
